<template>
  <div class="background_index_concept">
    <div class="index_concept_text">
      <p style=" font-size: 22px;margin-bottom: 0.5vh;">Value</p>
      <p style="padding-bottom: 1vh">——————</p>
      <p> SIG endeavors to find companies with unique value propositions.</p>
      <p>We believe that a truly great business starts with a distinctive business idea and stands out for its core
        values and beliefs.</p>
      <p>We never stop looking for the companies that genuinely solve problems and may change the world in the
        future.</p>
      <p>When we find such a company, we stay in it for the long-run.</p>

    </div>
    <div class="index_down_button">
      <a-button type="ghost" shape="circle-outline" size="large">
        <template v-slot:icon>
          <DownOutlined/>
        </template>
      </a-button>
    </div>
  </div>
</template>
<script>
import {DownOutlined} from "@ant-design/icons-vue/"

export default {
  name: 'Index_concept_en_m',
  setup() {
    const next_page = () => {  //跳转下一页
      document.documentElement.scrollBy({
        top: window.innerHeight,
        behavior: "smooth",
      })
    }
    return {next_page}
  },
  components: {
    DownOutlined,
  }
}
</script>
<style scoped>
.background_index_concept {
  background-image: url("../../../assets/background/index_concept.jpg");
  height: 100vh;

  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
  margin: 0;
}

.index_concept_text {
  padding-top: 25vh;
  height: 92vh;
}

.index_concept_text p {
  font-size: 12px;
}

.index_concept_card {
  padding-top: 4vh;
  color: white;
}

.card_img {
  width: 45px;
}

.card_text {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
}

.index_down_button {
  height: 5vh;
  position: relative;
  bottom: 2vh;
}

</style>